import { actions } from '../../utils/constants';
import CredentialsHelper from '../../utils/credentials-helper';

export const logout = () => {
    CredentialsHelper.clear();
    return {
        type: actions.LOGOUT_DO,
    };
};



// WEBPACK FOOTER //
// ./src/components/header/header.action.js